<template>
  <div class="home bg-white w-full p-4 py-6">
    <Loading v-show="loading" class="top-0 left-0 bg-[rgba(0,0,0,0.25)]"/>
  </div>
</template>

<script setup>
import {
  computed, nextTick,
} from 'vue';

import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';

import { formatISOToDate } from '@/utilities/helpers';

import Loading from '@/components/LoadingOverlay.vue';

// const emit = defineEmits(['buyGold', 'completeProfile'])
const route = useRoute();
const router = useRouter();
const store = useStore();

const loading = computed(() => {
  const loadingGlobal = store.state.global.loading;
  return loadingGlobal;
});

// // eslint-disable-next-line no-unused-vars
// const screeningData = computed(() => {
//   const screening = store.state.screening.screeningData;
//   return screening;
// });

async function getScreeningData() {
  const res = await store.dispatch('screening/getScreeningData', {
    token: route.query.token,
    dob: formatISOToDate(route.query.dob),
  });
  return res;
}

async function passDate() {
  if (route.query.dob) {
    const res = await getScreeningData();
    if (res === true) {
      localStorage.setItem(encodeURIComponent(route.query.token), JSON.stringify([formatISOToDate(route.query.dob)]));
      store.dispatch('global/setDob', route.query.dob, { root: true });
      await nextTick();
      router.push(`/result?token=${encodeURIComponent(route.query.token)}&page=${route.query.page}`);
    }
  }
}

passDate();
</script>

<script>
export default {
  name: 'HomePageCmsView',
};
</script>
